import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { getAllCustomer, toggleCustomer } from "../../actions/CustomerActions";
import Webmenu from "../../layouts/webmenu";
import Topbar from "../../layouts/topbar";
import DataTable from "react-data-table-component";
import { ThreeDots } from "react-loader-spinner";
import { assignDriverOut, getAllVehicleReplacement, getVehicleReplacementById, passOn, saveTechincalReport } from "../../actions/VehicleReplacementsActions";
import { getAllDriver } from "../../actions/DriverActions";
import { styleSelect } from "../../constants/customStyles";
import Select from 'react-select';
import Toast from "../../components/Toast";
import Mobilemenu from "../../layouts/mobile-menu";

function ReplacementOfVehicle() {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [page, setPage] = useState(1);
    const [currentRowsPerPage, setCurrentRowsPerPage] = useState(10);
    const [paginationTotalRows, setPaginationTotalRows] = useState(0);

    const loading = useSelector(state => state?.loading?.loading);
    const vehicleReplacements = useSelector(state => state?.vehicleReplacements?.vehicleReplacements?.data)
    const vehicleReplacementsPagination = useSelector(state => state?.vehicleReplacements?.vehicleReplacements)
    const user_permissions = JSON.parse(localStorage.getItem('perm'));

    useEffect(() => {
        dispatch(getAllVehicleReplacement(page, currentRowsPerPage, filter ?? ''));
        dispatch(getAllCustomer(null, 9999, { status: 1 }));
    }, [currentRowsPerPage])

    const onChangePage = (page) => {
        // page)
        dispatch(getAllVehicleReplacement(page, currentRowsPerPage, filter ?? ''));
    }

    useEffect(() => {
        // Update the paginationTotalRows prop to reflect the actual number of rows that are available
        setPaginationTotalRows(vehicleReplacementsPagination.total);
    }, [vehicleReplacementsPagination]);
    // const toggleStatus = (id) => {
    //     dispatch(toggleCustomer(id));
    // }

    const customStyles = {
        table: {
            style: {
                backgroundColor: 'rgb(241, 245, 248)',
            },
        },
        headRow: {
            style: {
                border: 'none !important'
            }
        },
        head: {
            style: {
                fontWeight: 'bold',
                fontSize: '14px',
                border: 'none !important',
            }
        },
        rows: {
            style: {
                minHeight: '60px', // override the row height
                backgroundColor: '#fff !important',
                borderTop: 'none !important',
                marginBottom: '10px',
                borderRadius: '30px',
                paddingRight: '5px',
                '&:not(:last-of-type)': {
                    border: 'none'
                }
            },
        },
        body: {
            style: {
                backgroundColor: 'rgb(241, 245, 248)',
            }
        },
        headCells: {
            style: {
                paddingLeft: '20px', // override the cell padding for head cells
                paddingRight: '20px',
                fontSize: '14px',
                fontWeight: '700',
                textTransform: 'uppercase',
                border: 'none !important',
                backgroundColor: 'rgb(241, 245, 248)',
                // justifyContent: 'center'
            },
        },
        cells: {
            style: {

                fontSize: '14px',
                // 'div:first-child': {
                //     overflow: 'visible !important'
                // }
                // justifyContent: 'center'
            },
        },
        pagination: {
            style: {
                backgroundColor: 'rgb(241,245,248)',
                borderTop: 'none !important',
            },
        }
    };

    const passOnCase = (id) => {
        dispatch(passOn(id));
    }

    const columns = [
        {
            name: 'ID',
            selector: (row, index) => index + 1,
            width: '12%'
        },
        {
            name: 'CUSTOMER NAME',
            selector: row => row?.customer_name,
        },
        {
            name: 'PLATE NUMBER',
            selector: row => row?.vehicle?.plate_number,
        },
        {
            name: 'VEHICLE CODE',
            selector: row => row?.vehicle?.vehicle_code?.name,
        },
        {
            name: 'STATUS',
            selector: row => row?.replace_vehicle_status_master?.name,
        },
        {
            name: 'CASE',
            selector: row => row?.status == 1 ? 'Default' : 'Pass On',
        },
        // {
        //     name: 'STATUS',
        //     selector: row => <div className="d-flex align-items-center form-check form-switch">
        //         <input onChange={(e) => toggleStatus(row.customer_id)} type="checkbox"
        //             defaultChecked={row.status} className="form-check-input" />
        //     </div>,
        // },
        {

            selector: row => (
                user_permissions.some(item => item.permission_id == '22') ? (
                    <div className="dropdown">
                        <button className="dropdown-toggle btn px-2 box text-gray-700 dark-text-gray-300" aria-expanded="false" data-bs-toggle="dropdown">
                            <span className="d-flex align-items-center fs-base justify-content-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-settings me-1 w-6 h-6"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg>
                                Actions
                            </span>
                        </button>
                        <div className="dropdown-menu w-48">
                            <div className="dropdown-content">
                                <Link className="d-flex align-items-center fs-base py-1" to={`/replacementOfVehicle/${row.id}`}> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-edit me-1 w-6 h-6"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg> Edit </Link>
                                <Link className="d-flex align-items-center fs-base py-1" to={`/tracking/${row.id}`}> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-map-pin me-1 w-6 h-6 "><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg> Tracking </Link>
                                {
                                    row?.replace_vehicle_status_master?.id >= 6 &&
                                    <Link className="d-flex align-items-center py-1 fs-base" onClick={() => passOnCase(row.id)}> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-fast-forward me-1 w-6 h-6"><polygon points="13 19 22 12 13 5 13 19"></polygon><polygon points="2 19 11 12 2 5 2 19"></polygon></svg> Pass On </Link>
                                }
                                {
                                    row?.replace_vehicle_status_master?.id == 5 &&
                                    < Link className="d-flex align-items-center py-1 fs-base" to={`/investigation/add/${row.id}`}> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-search me-1 w-6 h-6"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg> Investigation </Link>
                                }
                                {
                                    row?.replace_vehicle_status_master?.id == 6 &&
                                    <span>
                                        <Link to={`/estimate/add/${row?.investigation?.investigation_id}`} className="d-flex fs-base align-items-center w-24 py-1"> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-file me-1 w-6 h-6"><path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path><polyline points="13 2 13 9 20 9"></polyline></svg> Estimate </Link>
                                        <Link data-bs-toggle="modal" data-bs-target="#technicalReportModal" onClick={(e) => onClickTechnicalReportModal(e, row.id)} className="d-flex align-items-center fs-base py-1 me-3"> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-file me-1 w-6 h-6"><path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path><polyline points="13 2 13 9 20 9"></polyline></svg> Technical Report </Link>
                                    </span>
                                }
                                {
                                    row?.replace_vehicle_status_master?.id == 7 &&
                                    <span>
                                        <Link to={`/jobCard/add/${row?.estimate?.estimate_id}`} className="d-flex align-items-center py-1 fs-base w-24 me-3"> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-file me-1 w-6 h-6"><path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path><polyline points="13 2 13 9 20 9"></polyline></svg> Job Card </Link>
                                        <Link data-bs-toggle="modal" data-bs-target="#technicalReportModal" onClick={(e) => onClickTechnicalReportModal(e, row.id)} className="d-flex align-items-center fs-base py-1 fs-base me-3"> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-file me-1 w-6 h-6"><path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path><polyline points="13 2 13 9 20 9"></polyline></svg> Technical Report </Link>
                                    </span>
                                }
                                {
                                    row?.replace_vehicle_status_master?.id == 9 &&
                                    <Link className="d-flex align-items-center fs-base py-1" onClick={(e) => onClickAssignModal(e, row.id)} data-bs-toggle="modal" data-bs-target="#assignDriverModal"> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-edit me-1 w-6 h-6"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg> Assign Driver </Link>
                                }
                            </div>
                        </div>
                    </div >
                ) : null
            )
        },
    ];

    const onClickAssignModal = (e, id) => {
        dispatch(getVehicleReplacementById(id));
        dispatch(getAllDriver(null, 99999));
    }

    const vehicleReplacement = useSelector(state => state?.vehicleReplacements?.vehicleReplacement);
    const drivers = useSelector(state => state?.drivers?.drivers);
    const customers = useSelector(state => state?.customer?.customers?.data);

    const [driverOut, setDriverOut] = useState('');

    const assignDriver = async () => {
        if (driverOut == '') {
            Toast.fire({
                icon: 'error',
                title: 'Driver is Required!'
            })
        } else {
            let data = {
                driver_out: driverOut?.driver_id,
            }
            await dispatch(assignDriverOut(data, vehicleReplacement?.id))
            dispatch(getAllVehicleReplacement(page, currentRowsPerPage));
        }
    }

    const onClickTechnicalReportModal = (e, id) => {
        dispatch(getVehicleReplacementById(id));
    }

    const [problem, setProblem] = useState('')
    const [observation, setObservation] = useState('')
    const [cause, setCause] = useState('')
    const [scope, setScope] = useState('')

    const TechnicalReport = async () => {
        if (problem == '') {
            Toast.fire({
                icon: 'error',
                title: 'Problem Reported is Required!'
            })
        } else if (observation == '') {
            Toast.fire({
                icon: 'error',
                title: 'Observation is Required!'
            })
        } else if (cause == '') {
            Toast.fire({
                icon: 'error',
                title: 'Cause Of Damage is Required!'
            })
        } else if (scope == '') {
            Toast.fire({
                icon: 'error',
                title: 'Scope of the Job is Required!'
            })
        } else {
            let data = {
                vehicle_id: vehicleReplacement?.vehicle_id,
                company_id: vehicleReplacement?.company_id,
                problem: problem,
                observation: observation,
                cause: cause,
                scope: scope,
            }
            dispatch(saveTechincalReport(data, vehicleReplacement?.id, navigate))
        }
    }

    const [filter, setFilter] = useState('');

    const handleFilter = (event) => {
        setFilter({
            ...filter,
            [event.target.name]: event.target.value,
        })
    }
    const handleFilterDropdown = (event) => {
        setFilter({
            ...filter,
            'customer_id': event.id,
            'customer_name': event.name,
        })
    }

    const handleClearFilter = () => {
        setFilter('')
        dispatch(getAllVehicleReplacement(page, currentRowsPerPage, ''))
    }

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            filterSearch();
        }
    }

    const filterSearch = () => {
        dispatch(getAllVehicleReplacement(page, currentRowsPerPage, filter ?? ''))
    }

    return (

        <React.Fragment>
            <Mobilemenu />
            <div className="content-body d-flex">
                <Webmenu />
                <div className="content">
                    <Topbar />
                    {/* {
                        loading ?
                            <ThreeDots
                                height="80"
                                width="80"
                                radius="9"
                                color="#2d3748"
                                ariaLabel="three-dots-loading"
                                wrapperStyle={{ justifyContent: 'center', alignItems: 'center', height: '100%' }}
                                wrapperClassName=""
                                visible={loading}
                            /> : */}
                    <span>
                        <h2 className="intro-y fs-lg fw-medium mt-10">
                            Replacement of Vehicles
                        </h2>
                        <div className="intro-y g-col-12 d-flex flex-wrap flex-sm-nowrap justify-content-between align-items-center mt-2">
                            {
                                user_permissions.some(item => item.permission_id == '21') &&
                                <Link to="/replacementOfVehicle/add">
                                    <button className="btn btn-primary shadow-md me-2">Add New</button>
                                </Link>
                            }
                            <button class="btn btn-primary ms-auto d-flex align-items-center dark-text-theme-10" type="button"
                                data-bs-toggle="collapse" data-bs-target="#faq-accordion-collapse-1" aria-expanded="true"
                                aria-controls="faq-accordion-collapse-1">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-filter w-4 h-4 me-3"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon></svg>
                                Filters </button>
                        </div>
                        <div id="faq-accordion-collapse-1" class="accordion-collapse collapse show mt-5" aria-labelledby="faq-accordion-content-1"
                            data-bs-parent="#faq-accordion-1">
                            <div class="grid columns-12 gap-6 mt-5">
                                <div class="intro-y g-col-12 g-col-lg-12">
                                    <div class="intro-y box p-5">
                                        <div class="row">
                                            <div class="col-lg-2 col-md-6 mt-2">
                                                <div>
                                                    <label for="crud-form-1" class="form-label font-weight-bold">Date From</label>
                                                    <input id="crud-form-1" type="date" onKeyPress={handleKeyPress} onChange={handleFilter} value={filter?.date_from} name="date_from"
                                                        class="form-control w-full" placeholder="Enter Date From." />
                                                </div>
                                            </div>
                                            <div class="col-lg-2 col-md-6 mt-2">
                                                <div>
                                                    <label for="crud-form-1" class="form-label font-weight-bold">Date To</label>
                                                    <input id="crud-form-1" type="date" onKeyPress={handleKeyPress} onChange={handleFilter} value={filter?.date_to} name="date_to"
                                                        class="form-control w-full" placeholder="Enter Date to." />
                                                </div>
                                            </div>
                                            <div class="col-lg-3 col-md-6 mt-2">
                                                <div>
                                                    <label for="crud-form-1" class="form-label font-weight-bold">Customer Name</label>
                                                    <Select onChange={handleFilterDropdown} value={filter.customer_id ? { customer_id: filter?.customer_id, name: filter?.customer_name } : null} getOptionLabel={(option) => `${option.name}`} getOptionValue={(option) => `${option.customer_id}`} options={customers && customers.length > 0 ? customers : []} styles={styleSelect} placeholder="Select Customer" />
                                                </div>
                                            </div>
                                            <div class="col-lg-3 col-md-6 mt-2">
                                                <div>
                                                    <label for="crud-form-1" class="form-label font-weight-bold">Plate No #</label>
                                                    <input id="crud-form-1" type="text" onKeyPress={handleKeyPress} onChange={handleFilter} value={filter?.vehiclePlateNo} name="plate_number"
                                                        class="form-control w-full" placeholder="Enter Plate No." />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="text-end mt-5">
                                            <button type="submit" class="btn btn-elevated-primary w-24 me-2" onClick={() => filterSearch()}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search w-4 h-4 me-2"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
                                                Search</button>
                                            <button onClick={handleClearFilter} type="button" class="btn btn-elevated-danger w-24"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x w-4 h-4 me-2"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg> Clear</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        < div className="intro-y g-col-12">
                            <div className='mt-2'>
                                {/* <DataTable
                                    className="overflow-visible"
                                   columns={columns.map(column => ({
                                                    ...column,
                                                    cell: column.cell ? column.cell : (row) => (
                                                        <div>
                                                            {column.selector(row)}
                                                        </div>
                                                    ),
                                                }))}
                                    data={vehicleReplacements && vehicleReplacements.length > 0 ? vehicleReplacements : []}
                                    striped={true}
                                    highlightOnHover={true}
                                    pagination={true}
                                    customStyles={customStyles}
                                    responsive={true}
                                    paginationTotalRows={vehicleReplacements && vehicleReplacements.length > 0 ? vehicleReplacementsPagination.total : 0}
                                    paginationServer={true}
                                    onChangePage={(page) => onChangePage(page)}
                                    paginationRowsPerPageOptions={[10, 20, 50, 100]}
                                    onChangeRowsPerPage={(currentRowsPerPage, currentPage) => setCurrentRowsPerPage(currentRowsPerPage)}
                                    paginationPerPage={10}
                                /> */}
                                <DataTable
                                    // title="Users"
                                    className="overflow-lg-visible"
                                   columns={columns}
                                    data={vehicleReplacements && vehicleReplacements.length > 0 ? vehicleReplacements : []}
                                    progressPending={loading}
                                    progressComponent={<ThreeDots
                                        height="80"
                                        width="80"
                                        radius="9"
                                        color="#2d3748"
                                        ariaLabel="three-dots-loading"
                                        wrapperStyle={{ justifyContent: 'center', alignItems: 'center', height: '100%' }}
                                        wrapperClassName=""
                                        visible={loading}
                                    />}
                                    pagination
                                    paginationServer
                                    customStyles={customStyles}
                                    paginationTotalRows={paginationTotalRows}
                                    onChangeRowsPerPage={(currentRowsPerPage) => setCurrentRowsPerPage(currentRowsPerPage)}
                                    onChangePage={(page) => onChangePage(page)}
                                />
                            </div>
                        </div>
                    </span>
                    {/* } */}
                </div>
                <div id="assignDriverModal" class="modal fade" tabindex="-1" aria-hidden="true">
                    <div class="modal-dialog modal-lg">
                        <div class="modal-content">
                            {/* <!-- BEGIN: Modal Header --> */}
                            <div class="modal-header">
                                <h2 class="fw-medium fs-base me-auto">Assign Driver</h2>
                            </div>
                            {/* <!-- END: Modal Header --> */}
                            {/* <!-- BEGIN: Modal Body --> */}
                            <div className="intro-y p-5">
                                <div className="grid columns-12 gap-6">
                                    <div className="intro-y g-col-12 g-col-sm-6">
                                        <label for="name" className="form-label">Customer Vehicle Plate No. :</label>
                                        <input id="name" name="name" type="text" disabled value={vehicleReplacement?.vehicle?.plate_number} className="form-control" />
                                    </div>
                                    <div className="intro-y g-col-12 g-col-sm-6">
                                        <label for="variant" className="form-label">Replacement Vehicle Plate No. :</label>
                                        <input id="variant" name="variant" type="text" disabled value={vehicleReplacement?.replaceable_vehicle?.plate_number} className="form-control" />
                                    </div>
                                    <div className="g-col-12 g-col-md-12">
                                        <label for="crud-form-1" className="form-label">Drivers</label>
                                        <Select
                                            styles={styleSelect}
                                            getOptionLabel={(option) => `${option.driver_name}`}
                                            onChange={(e) => setDriverOut(e)}
                                            getOptionValue={(option) => `${option.id}`}
                                            options={drivers && drivers.length > 0 ? drivers : []}
                                        />
                                        {/* <Select styles={styleSelect} value={driverOut} onChange={(e) => setDriverOut(e)} getOptionLabel={(option) => `${option.name}`} getOptionValue={(option) => `${option.driver_id}`} options={drivers && drivers.length > 0 ? drivers : []} /> */}
                                    </div>
                                    {/* <div className="intro-y g-col-12 g-col-sm-6">
                                    <label for="image" className="form-label">Image :</label>
                                    <input id="image" name="image" type="file" className="form-control" />
                                </div> */}
                                </div>
                            </div>
                            {/* <!-- END: Modal Body --> */}
                            {/* <!-- BEGIN: Modal Footer --> */}
                            <div class="modal-footer text-end">
                                <div className="text-end">
                                    <button type="button" data-bs-dismiss="modal" className="btn btn-outline-secondary w-24 me-1">Back</button>
                                    <span>
                                        <button type="button" data-bs-dismiss="modal" onClick={assignDriver} className="btn btn-primary w-24 me-1">Save</button>
                                    </span>
                                </div>
                            </div>
                            {/* <!-- END: Modal Footer --> */}
                        </div>
                    </div>
                </div>
                <div id="technicalReportModal" class="modal fade" tabindex="-1" aria-hidden="true">
                    <div class="modal-dialog modal-lg">
                        <div class="modal-content">
                            {/* <!-- BEGIN: Modal Header --> */}
                            <div class="modal-header">
                                <h2 class="fw-medium fs-base me-auto">Technical report</h2>
                            </div>
                            {/* <!-- END: Modal Header --> */}
                            {/* <!-- BEGIN: Modal Body --> */}
                            <div className="intro-y py-3 px-5">
                                <div className="grid columns-12 gap-3">
                                    <div className="g-col-12 g-col-sm-12">
                                        <input id="vehicle_id" name="vehicle_id" type="hidden" disabled value={vehicleReplacement?.vehicle_id} className="form-control" />
                                        <label for="name" className="form-label">Customer Vehicle Plate No. :</label>
                                        <input id="name" name="name" type="text" disabled value={vehicleReplacement?.vehicle?.plate_number} className="form-control" />
                                    </div>
                                    <div className="g-col-12 g-col-sm-12">
                                        <label for="crud-form-1" className="form-label">Problem Reported :</label>
                                        <textarea name="problem" id="problem" value={problem} onChange={(e) => setProblem(e.target.value)} className="form-control" cols="10" rows="3"></textarea>
                                    </div>
                                    <div className="g-col-12 g-col-sm-12">
                                        <label for="crud-form-1" className="form-label">Observation :</label>
                                        <textarea name="observation" id="observation" value={observation} onChange={(e) => setObservation(e.target.value)} className="form-control" cols="10" rows="3"></textarea>
                                    </div>
                                    <div className="g-col-12 g-col-sm-12">
                                        <label for="crud-form-1" className="form-label">Cause of Damage :</label>
                                        <textarea name="cause" id="cause" value={cause} onChange={(e) => setCause(e.target.value)} className="form-control" cols="10" rows="3"></textarea>
                                    </div>
                                    <div className="g-col-12 g-col-sm-12">
                                        <label for="crud-form-1" className="form-label">Scope of the Job :</label>
                                        <textarea name="scope" id="scope" value={scope} onChange={(e) => setScope(e.target.value)} className="form-control" cols="10" rows="3"></textarea>
                                    </div>
                                    {/* <div className="intro-y g-col-12 g-col-sm-6">
                                    <label for="image" className="form-label">Image :</label>
                                    <input id="image" name="image" type="file" className="form-control" />
                                </div> */}
                                </div>
                            </div>
                            {/* <!-- END: Modal Body --> */}
                            {/* <!-- BEGIN: Modal Footer --> */}
                            <div class="modal-footer text-end">
                                <div className="text-end">
                                    <button type="button" data-bs-dismiss="modal" className="btn btn-outline-secondary w-24 me-1">Back</button>
                                    <span>
                                        <button type="button" data-bs-dismiss="modal" onClick={TechnicalReport} className="btn btn-primary w-24 me-1">Save</button>
                                    </span>
                                </div>
                            </div>
                            {/* <!-- END: Modal Footer --> */}
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment >
    )
}

export default ReplacementOfVehicle;